import { ABS, INT, MAX, MIN, MOD, UPPERMONEY, ROUND, AVG, SUM, NUMBER, MONEYFORMAT } from './maths'
import { GETDAY, GETHOUR, GETMINUTE, GETMONTH, GETQUARTER, GETSECOND, GETWEEK, GETYEAR, DATENOW, MINUTE, HOUR, DAY, WEEKDAY, MONTH, YEAR, DATEIF, DATEFORMAT, DATEADD, DATESUBSTRACT, MOMENT, MONTHDAY } from './dates'
import { IF, OR, AND, NOT, ISEMPTY, INCLUDE, FALSE, TRUE } from './logic'
import { CONCAT, REPLACE, MID, LEFT, RIGHT, TRIM, CLEAN, LOWER, UPPER, FIND, FINDALL, SPLIT, JOIN, STRING } from './text'
import { SOCIAL_SECURITY_ROUND } from './privates'
export default {
  // 数学函数
  ABS, INT, MAX, MIN, MOD, UPPERMONEY, ROUND, AVG, SUM, NUMBER, MONEYFORMAT,
  // 日期函数
  GETDAY, GETHOUR, GETMINUTE, GETMONTH, GETQUARTER, GETSECOND, GETWEEK, GETYEAR, DATENOW, MINUTE, HOUR, DAY, WEEKDAY, MONTH, YEAR, DATEIF, DATEFORMAT, DATEADD, DATESUBSTRACT, MOMENT, MONTHDAY,
  // 逻辑函数
  IF, OR, AND, NOT, ISEMPTY, INCLUDE, FALSE, TRUE,
  // 文本函数
  CONCAT, REPLACE, MID, LEFT, RIGHT, TRIM, CLEAN, LOWER, UPPER, FIND, FINDALL, SPLIT, JOIN, STRING,
  // 内置函数
  SOCIAL_SECURITY_ROUND
}
